import { TrainVariantDoorForCheckList } from "./TrainVariantDoorForCheckList";


export class TrainAndDoorsForChecklist {
    isSelected: boolean;
    id: number;
    name: string;
    doors: TrainVariantDoorForCheckList[];
    acrossDeckAreaSelection: SelectableArea[];
    separatDeckAreaSelection: SelectableArea[];
    hasTrainConfiguration: boolean;
    hasDeletedVariants: boolean;
    hasSecondDeck: boolean;
}

export class SelectableArea {
    isSelected: boolean;
    name: string;
}
